module.exports = __webpack_public_path__ + "static/media/sql-server.0bdb284c.png";